<template>
  <div class="mini-calendar__date-filter">
    <VDatePicker v-model="range" is-range>
      <template v-slot="{ inputValue, inputEvents }">
        <input
          class="mini-calendar__date-filter-field"
          :value="inputValue.start"
          v-on="inputEvents.start"
          type="text"
          aria-label="start date"
        />

        <input
          class="mini-calendar__date-filter-field"
          :value="inputValue.end"
          v-on="inputEvents.end"
          type="text"
          aria-label="end date"
        />
      </template>
    </VDatePicker>
    <button type="button" class="button" @click="onclick">Update</button>
  </div>
</template>

<script>
import moment from "moment";
import { getFilteredEvents } from "./../../api";
import { mapActions, mapGetters } from "vuex";
import { DATE_FORMAT } from "@/utils/config";

export default {
  name: "MiniCalenderDateFilter",
  data() {
    return {
      range: {
        start: new Date(),
        end: new Date(),
      },
    };
  },
  computed: {
    ...mapGetters(["date_range"]),
  },
  watch: {
    date_range: function (newVal) {
      this.range = {
        start: newVal.start ? new moment(newVal.start).toDate() : new Date(),
        end: newVal.end ? new moment(newVal.end).toDate() : new Date(),
      };
    },
  },
  methods: {
    onclick() {
      let start = moment(this.range.start).format(DATE_FORMAT);
      let end = moment(this.range.end).format(DATE_FORMAT);
      this.setLoading(true);

      getFilteredEvents(start, end)
        .then((response) => {
          if (response) {
            let data = response.data ? response.data : [];

            this.setEventList({ eventlist: data, total: response.query.total });
            this.setDateRange({
              type: "custom_range",
              start: start,
              end: end,
            });
          }
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    ...mapActions(["setDateRange", "setEventList", "setLoading"]),
  },
};
</script>

<style lang="scss">
.mini-calendar__date-filter {
  padding: 0.25rem 2.5rem;
  &-field {
    border: 1px solid $border-color;
    font-size: 1rem;
    padding: rem(6) rem(14);
    line-height: 1.5;
    background: $background-color;
    border-radius: rem(5);
    display: inline-block;
    margin-bottom: rem(10);
    width: 100%;
  }
}
</style>
